@if (workflowSteps.length > 0) {
    <cerrix-workflow-bar [steps]="workflowSteps"></cerrix-workflow-bar>
}
<app-cerrix-breadcrumb [crumbs]="breadcrumbs"></app-cerrix-breadcrumb>
<div class="name-and-instructions-container">
    @if (edit) {
        <div class="asset-name-field-wrapper">
            <input
                class="asset-name-field"
                name="asset-name"
                validationErrors
                appValidationRequired
                [validationRequiredMessage]="requiredMessage"
                [validationMaxLength]="maxLength"
                [(value)]="title"
                (input)="titleChange.emit($event.target.value)"
                required
            />
            @if (!title?.trim()) {
                <span class="placeholder-overlay"
                    >{{ titlePlaceholder }} <span class="required">*</span></span
                >
            }
        </div>
    } @else {
        <div class="title-container">
            <cerrix-title [text]="title"></cerrix-title>
            @if (editIcon) {
                <cerrix-icon-button
                    data-uiid="cerrix-header-edit-button"
                    [icon]="editIcon"
                    [ariaLabel]="'editLabel' | t"
                    buttonSize="small"
                    [showBorder]="false"
                    (click)="editRequested.emit()"
                />
            }
        </div>
    }
</div>
